import { styled } from "@material-ui/core";
import { Button, div, Flex, Input, Link, PopupDialog } from "lqx-react/lib";
import React from "react";

export const MultipleSelectionsPopup = ({ onMultipleSelectionsApply, onClose, mappings }
  : { onMultipleSelectionsApply: any, onClose: any, mappings: string[] }) => {
  return (
    <>
      <PopupDialog
        title=''
        actions={
          <>
            <Button onClick={onMultipleSelectionsApply}>
              Apply
            </Button>
          </>
        }
        maxWidth='sm'
        hideTitle={true}
        onClose={onClose}
      >
        <TargetHeaderRowLabel>
          You have selected {mappings.length} header fields
        </TargetHeaderRowLabel>
        <CancelSelection color="primary" onClick={onClose}>
          Select new header fields
        </CancelSelection>
        <Flex row wrap alignCenter>
          {mappings.map((item, index) =>
            (<TargetHeaderRowInput key={index} disabled value={item} />))
          }
        </Flex>
      </PopupDialog>
    </>
  );
};

const TargetHeaderRowLabel = div({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: 'rgba(0, 0, 0, 0.54)'
});

const CancelSelection = styled(Link)({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: '#4197d6'
});

const TargetHeaderRowInput = styled(Input)({
  maxWidth: '250px',
  padding: '4px',
  margin: '5px'
});